// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20hCA","index":"styles_index__1BNJp"};